import axios from "axios";

import {  Decrypt } from "../services/data-encription";
import {middlewareEncryption, middlewareDecryption} from "./index";

export const getDealershipKycDetails = (id) => {
    return middlewareDecryption(`/api/dealership/getDealershipDetails/${id}`);
};

export const getBrandDetails = () => {
    return middlewareDecryption(`/api/dealership/getBrandDetails`);
};

export const getAllProducts = () => {
    return middlewareDecryption(`/api/dealership/getAllProducts`);
};

export const getUserDetails = (email) => {
    return middlewareDecryption(`/api/dealership/getUserDetails/${email}`);
};

export const getCategoryDetails = () => {
    return middlewareDecryption(`/api/dealership/getCategoryDetails`);
};

export const getCompanyAndCertDetails = async (page) => {
//     const token = localStorage.getItem("token")
//     const headers = {
//         'Authorization': token,
//     }
//     let result = await axios.get(`${process.env.REACT_APP_SERVER_URL_TEMP}/api/dealership/getCompanyAndCertDetails/${page}`, { headers })
//     if ("result" in result.data) {
//         result.data.result = Decrypt(result.data.result);
//     }
//     return result;
    return middlewareDecryption(`/api/dealership/getCompanyAndCertDetails/${page}`);
};

export const getMappingDetails = async () => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token,
    }
    let result = await axios.get(`${process.env.REACT_APP_SERVER_URL_TEMP}/api/dealership/getMappingDetails`, { headers })
    if ("result" in result.data) {
        result.data.result = Decrypt(result.data.result);
    }
    return result
    // return middlewareDecryption(`/api/dealership/getMappingDetails`);
};

export const getModels = async () => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token,
    }
    let result = await axios.get(`${process.env.REACT_APP_SERVER_URL_TEMP}/api/dealership/getAllModels`, { headers })
    if ("result" in result.data) {
        result.data.result = Decrypt(result.data.result);
    }
    return result
    // return middlewareDecryption(`/api/dealership/getAllModels`);
};

export const getVariants = async () => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token,
    }
    let result = await axios.get(`${process.env.REACT_APP_SERVER_URL_TEMP}/api/dealership/getAllVariants`, { headers })
    if ("result" in result.data) {
        result.data.result = Decrypt(result.data.result);
    }
    return result
    // return middlewareDecryption(`/api/dealership/getAllVariants`);
};

export const getBillingAddress = () => {
    return middlewareDecryption(`/api/dealership/getBillingAddress`);
};

export const savePancardDetails = (data) => {
    return middlewareEncryption(`/api/dealership/savePancard`, data)
};

export const savePolicyHistory = (data) => {
    return middlewareEncryption(`/api/dealership/saveHistory`, data)
};

export const saveGstnDetails = (data) => {
    return middlewareEncryption(`/api/dealership/saveGstn`, data)
};

export const saveBankDetails = (data) => {
    return middlewareEncryption(`/api/dealership/saveBankDetails`, data)
};
export const saveSignatoryDetails = (data) => {
    return middlewareEncryption(`/api/dealership/saveSignatoryDetails`, data)
};

export const savePolicyDetails = (data) => {
    return middlewareEncryption(`/api/dealership/savePolicyDetails`, data)
};

export const saveTransactionStatus = (data) => {
    return middlewareEncryption(`/api/payment/saveTransactionStatus`, data)
};

export const saveBulkPolicyDetails = (data) => {
    return middlewareEncryption(`/api/dealership/createBulkPolicies`, data)
};


export const saveBillingAddress = (data) => {
    return middlewareEncryption(`/api/dealership/saveBillingAddress`, data)
};

export const saveCancellationDetails = (data) => {
    return middlewareEncryption(`/api/dealership/saveCancellationDetails`, data)
};

export const getHashDetailsTest = async (data) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token,
        // 'Content-Type': 'multipart/form-data'
    }
    let result = await axios.post(`${process.env.REACT_APP_SERVER_URL_TEMP}/api/payment/payumoney`, data, { headers })
    return result
};
export const getHashDetails = (data) => {
    
    return middlewareEncryption(`/api/payment/payumoney`, data)
};
export const addMoneyInWallet = (data) => {
    
    return middlewareEncryption(`/api/dealership/addMoneyToWallet`, data)
};

export const reponseDetails = (data) => {
    return middlewareEncryption(`/api/payment/response`, data)
};

export const saveKycFlag = (id, data) => {
    return middlewareEncryption(`/api/dealership/submitKyc`)
};

export const activateKyc = (id, data) => {
    return middlewareDecryption(`/api/dealership/activateKyc/${id}`)
};

export const getAllDspUser = (id) => {
    return middlewareDecryption(`/api/dealership/getDealerSalesPersonUsersList/${id}`)
};
export const getVehicleByChassis = (vin) => {
    return middlewareDecryption(`/api/sales/getvehicleBychessisNumber/${vin}`)
};  
export const checkPolicyForChassis = (data) => {
    return middlewareEncryption(`/api/dealership/checkPolicyForChassis`, data)
};
export const checkPolicyForRenewal = (data) => {
    return middlewareEncryption(`/api/dealership/checkPolicyForRenewal`, data)
};
export const getVehicleByChassisNumber = (data) => {
    return middlewareEncryption(`/api/sales/getVehicleByChassisNumber`, data)
};


export const savePolicyDocumentDetails = (data) => {
    return middlewareEncryption(`/api/partnership/createDocumentRevamp`, data)
};

// export const savePolicyDocumentDetails = (data) => {
//     return middlewareEncryption(`/api/partnership/createDocument`, data)
// };

export const bulkPolicyPunch = (data) => {
    return middlewareEncryption(`/api/partnership/punchBulkDocuments`, data)
};

export const creditMoneyToSM = (data) => {
    return middlewareEncryption(`/api/dealership/creditMoneyToSM`, data)
};

export const walletDebit = (data) => {
    return middlewareEncryption(`/api/dealership/walletDebit`, data)
};


export const downloadCoa = (travelCareMembershipNo) => {
    return middlewareEncryption(`/api/partnership/downloadCoa`, {"document_unique_code":travelCareMembershipNo})
};  

export const downloadDocumentCertificate = (documentNo) => {
    return middlewareEncryption(`/api/partnership/downloadDocumentCertificate`, {"document_unique_code":documentNo})
};

export const downloadDocumentInvoice = (documentNo) => {
    return middlewareEncryption(`/api/affiliation/generatePdfFromBase64`, {"Document_No":documentNo})
};
export const downloadDocumentReceipt = (documentNo) => {
    return middlewareEncryption(`/api/affiliation/generateReceiptPdf`, {"Document_No":documentNo})
};
export const downloadCNInvoice = (documentNo) => {
    return middlewareEncryption(`/api/affiliation/generatePdfFromBase64CN`, {"Document_No":documentNo})
};

export const saveCashifyPolicyDetails = (data) => {
    return middlewareEncryption(`/api/partnership/punchPolicy`, data)
};